import { RoutersDefinition } from '@wix/document-services-types';
import { RoutersDefinitionWithId } from '@wix/document-services-types/src/rendererModel';

function getRouterConfig(
  routerData: RoutersDefinition | RoutersDefinitionWithId,
) {
  return typeof routerData.config === 'string'
    ? JSON.parse(routerData.config)
    : JSON.parse(JSON.stringify(routerData.config));
}

export { getRouterConfig };
